// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__317ow","requiredAsterisk":"Info_requiredAsterisk__3Tr0K"};